import { IEmailData } from "Dashboard/domain/IEmailData";
import { ILicense } from "Dashboard/domain/ILicense";
import { IMemorandumData } from "Dashboard/domain/IMemorandumData";
import { IMessage } from "domain/IMessage";
import { IProvision } from "Dashboard/domain/IProvision";
import API from "utils/API";
import authHeader from "utils/auth-header";
import { IChangeHourlyRateNameRequestParams } from "Dashboard/domain/hourly_work/IChangeHourlyRateNameRequestParams";
import { IAddHourlyRateNameRequestParams } from "Dashboard/domain/hourly_work/IAddHourlyRateNameRequestParams";
import { IUpdateProvisionRequestParams } from "Dashboard/domain/IUpdateProvisionRequestParams";

const getLicense = async (): Promise<ILicense> => {
  var headers = authHeader();
  try {
    const response = await API.get<ILicense>("/settings/public/license", {
      headers,
    });
    let license = response.data;
    return license;
  } catch (err) {
    throw err;
  }
};

const updateLicense = (license: ILicense) => {
  var headers = authHeader();
  try {
    API.post<ILicense>("/settings/protected/license", license, { headers });
  } catch (err) {
    throw err;
  }
};

const getProvision = async (): Promise<IProvision> => {
  var headers = authHeader();
  try {
    const response = await API.get<IProvision>(
      "/settings/public/provision",
      { headers }
    );
    let provision = response.data;
    return provision;
  } catch (err) {
    throw err;
  }
};

const updateProvision = async (params: IUpdateProvisionRequestParams) => {
  var headers = authHeader();
  try {
    const response = await API.post<IProvision>("/settings/protected/provision", params, {
      headers,
    });
    let provision = response.data;
    return provision;
  } catch (err) {
    throw err;
  }
};

const addHourlyRateName = async (params: IAddHourlyRateNameRequestParams): Promise<IProvision> => {
  var headers = authHeader();
  try {
    const response = await API.post<IProvision>("/settings/protected/provision/hourly-rate-name", params, {
      headers,
    });
    return response.data;
  } catch (err) {
    throw err;
  }
};

const changeHourlyRateName = async (params: IChangeHourlyRateNameRequestParams): Promise<IProvision> => {
  var headers = authHeader();
  try {
    const response = await API.put<IProvision>("/settings/protected/provision/hourly-rate-name", params, {
      headers,
    });
    return response.data;
  } catch (err) {
    throw err;
  }
};

const getMemorandumData = async (): Promise<IMemorandumData> => {
  var headers = authHeader();
  try {
    const response = await API.get<IMemorandumData>(
      "/settings/public/memorandum-data",
      { headers }
    );
    let memorandumData = response.data;
    return memorandumData;
  } catch (err) {
    throw err;
  }
};

const updateMemorandumData = async (memorandumData: IMemorandumData) => {
  var headers = authHeader();
  try {
    await API.post<IMemorandumData>(
      "/settings/protected/memorandum-data",
      memorandumData,
      { headers }
    );
  } catch (err) {
    throw err;
  }
};

const getMemorandumLogo = async (): Promise<string> => {
  var headers = {
    ...authHeader(),
  };
  try {
    const response = await API.get<any>("/settings/public/memorandum-logo", {
      headers,
      responseType: "arraybuffer",
    });
    let image = btoa(
      new Uint8Array(response.data).reduce(
        (data, byte) => data + String.fromCharCode(byte),
        ""
      )
    );
    return response.headers["content-type"]
      ? `data:${response.headers["content-type"].toLowerCase()};base64,${image}`
      : "";
  } catch (err) {
    throw err;
  }
};

const uploadMemorandumLogo = async (image: any): Promise<IMessage> => {
  var headers = {
    "Content-Type": "multipart/form-data",
    ...authHeader(),
  };
  const data = new FormData();
  data.append("logoImage", image);
  try {
    const response = await API.post<IMessage>(
      "/settings/public/memorandum-logo",
      data,
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const getEmailData = async (): Promise<IEmailData> => {
  var headers = authHeader();
  try {
    const response = await API.get<IEmailData>("/settings/protected/email", {
      headers,
    });
    let emailData = response.data;
    return emailData;
  } catch (err) {
    throw err;
  }
};

const updateEmailData = (provision: IEmailData) => {
  var headers = authHeader();
  try {
    API.post<IEmailData>("/settings/protected/email", provision, { headers });
  } catch (err) {
    throw err;
  }
};

export const settingsService = {
  getLicense,
  updateLicense,
  getProvision,
  updateProvision,
  addHourlyRateName,
  changeHourlyRateName,
  getMemorandumLogo,
  uploadMemorandumLogo,
  getMemorandumData,
  updateMemorandumData,
  getEmailData,
  updateEmailData,
};
